export default {
    path: '/salescommission',
    meta: {
        title: '销售收款',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/salescommission`),
}


// WEBPACK FOOTER //
// ./src/views/SalesCommission/router.js